import { useRef, useState } from "react";
import "./ForgetPassword.scss";
import { Modal, Form, Input, Typography, message } from "antd";
import forgetPasswordSchema from "../../validations/forgetPasswordValidation.js";
import { createYupValidator } from "../../utils/validationHelper.js";
import { forgotPassword } from "../../features/forgetPassword/resetPasswordActions.js";
import { useDispatch } from "react-redux";
import { staticTextErrors } from "../../config/constantErrorTexts.js";

export default function ForgetPassword({
  token,
  isOpened,
  title,
  onCancel,
  openLogedInModal,
}) {
  const formRef = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const openMessage = (type, text) => {
    messageApi.open({
      type: type,
      content: text,
    });
  };
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const resetModalFields = () => {
    formRef?.current?.resetFields();
    setLoading(false);
    if (error) {
      setError(null);
    }
  };

  const handleCancelModal = () => {
    onCancel();
    resetModalFields();
  };

  const onOk = (values) => {
    setLoading(true);
    dispatch(forgotPassword(values))
      ?.then((res) => {
        if (res.type === "password_forgot/fulfilled") {
          handleCancelModal();
          openMessage(
            "success",
            res?.payload?.message
              ? res?.payload?.message
              : "Email successfully sent"
          );
        } else if (res.type === "password_forgot/rejected") {
          if (res?.payload?.message) {
            formRef?.current?.setFields([
              {
                name: "email",
                errors: Array.isArray(res?.payload?.message)
                  ? res?.payload?.message
                  : [res?.payload?.message],
              },
            ]);
          } else if (res?.payload?.email) {
            formRef?.current?.setFields([
              {
                name: "email",
                errors: Array.isArray(res?.payload?.email)
                  ? res?.payload?.email
                  : [res?.payload?.email],
              },
            ]);
          } else {
            openMessage(
              "error",
              res.payload && typeof res.payload === "string"
                ? res.payload
                : staticTextErrors?.SERVER_ERROR
            );
          }
          setLoading(false);
          setError(res?.payload);
        }
      })
      .catch(() => {
        setLoading(false);
        setError(null);
        openMessage("error", staticTextErrors?.SERVER_ERROR);
      });
  };

  return (
    <>
      {contextHolder}
      <Modal
        style={{
          borderTop: `2px solid ${token?.colorPrimary}`,
        }}
        className="forgetPasswordModal-cont"
        classNames={{
          footer: "forgetPasswordModal-cont__footer",
        }}
        destroyOnHidden={true}
        open={isOpened}
        title={title}
        centered={true}
        okText="Send to email"
        cancelText="Back"
        onCancel={() => {
          handleCancelModal();
        }}
        onOk={() => {
          formRef?.current?.submit();
        }}
        cancelButtonProps={{
          className: "forgetPasswordModal-cont__btn",
          size: "large",
          onClick: () => {
            handleCancelModal();
            openLogedInModal(true);
          },
        }}
        okButtonProps={{
          className: "forgetPasswordModal-cont__btn",
          htmlType: "submit",
          type: "primary",
          key: "submit",
          size: "large",
          loading: loading,
          disabled: error ? Object.keys(error)?.length !== 0 : false,
        }}>
        <Form
          className="forgetPasswordModal-cont__form"
          ref={formRef}
          layout="vertical"
          onFinish={(values) => {
            onOk(values);
          }}>
          <Form.Item
            className="forgetPasswordModal-cont__form__formItem"
            name="email"
            rules={[
              {
                required: true,
                validator: createYupValidator(forgetPasswordSchema, "email"),
              },
            ]}
            label={
              <Typography.Text className="forgetPasswordModal-cont__form__formItem__text">
                Email
              </Typography.Text>
            }
            colon={false}>
            <Input
              type="text"
              placeholder="Email"
              size="large"
              onChange={() => {
                if (error) {
                  setError(null);
                }
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
